/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Aai20Components } from '../../asyncapi/v2/models/Aai20Components';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SchemaDefinition } from '../../asyncapi/v2/models/Aai20SchemaDefinition';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { AaiSchemaFactory } from '../../core/factories/AaiSchemaFactory';
import { Document } from '../../core/models/Document';
import { NewSchemaDefinitionCommand } from './NewSchemaDefinitionCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';
import { IDefinition } from '../../core/models/common/IDefinition';

/**
 * @author laurent.broudoux@gmail.com
 * @extends NewSchemaDefinitionCommand
 * @class
 */
export class NewSchemaDefinitionCommand_Aai20 extends NewSchemaDefinitionCommand {
    public _nullComponents : boolean;

    public constructor(definitionName? : any, example? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((example != null) || example === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionExample = example;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && example === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSchemaDefinitionCommand_Aai20] Executing.");
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(doc20.components)) {
            doc20.components = doc20.createComponents();
            this._nullComponents = true;
        }
        this._nullComponents = false;
        let components : Aai20Components = <Aai20Components>doc20.components;
        if(this.isNullOrUndefined(components.getSchemaDefinition(this._newDefinitionName))) {
            let definition : Aai20SchemaDefinition;
            if(!this.isNullOrUndefined(this._newDefinitionExample)) {
                definition = <Aai20SchemaDefinition><any>AaiSchemaFactory.createSchemaDefinitionFromExample(doc20, this._newDefinitionName, this._newDefinitionExample);
                definition.example = this._newDefinitionExample;
            } else {
                definition = components.createSchemaDefinition(this._newDefinitionName);
                definition.type = "object";
            }
            if(ModelUtils.isDefined(this._newDefinitionDescription)) {
                definition.description = this._newDefinitionDescription;
            }
            components.addSchemaDefinition(this._newDefinitionName, definition);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSchemaDefinitionCommand_Aai20] Reverting.");
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this._nullComponents) {
            doc20.components = null;
        }
        if(this._defExisted) {
            return;
        }
        (<Aai20Components>doc20.components).removeSchemaDefinition(this._newDefinitionName);
    }
}
NewSchemaDefinitionCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.NewSchemaDefinitionCommand_Aai20";
NewSchemaDefinitionCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




